export const massageFilename = (file: File): File => {
  const newName =  file.name.replace(/([^a-zA-Z0-9-_. ])/g, '_');
  return new File([file], newName, { type: file.type });
};
